import { FC, ReactElement, useMemo } from 'react';
import classnames from 'classnames';

import { IHospitalCounters } from '~/services/api/hospital/types';
import styles from './HospitalCounters.module.scss';
import { AdtEventAction } from '~/services/api/enums';
import { getCards } from './constants';
import { ICard } from './types';

interface IProps {
  counters: IHospitalCounters;
  onClick: (eventIds: AdtEventAction[]) => void;
}

const HospitalCounters: FC<IProps> = ({ counters, onClick }): ReactElement => {
  const cards = useMemo<ICard[]>(() => getCards(counters, styles), [counters]);

  return (
    <div className={styles.container}>
      {cards.map(card => (
        <button
          type="button"
          key={card.title}
          className={styles.card}
          onClick={() => onClick(card.eventIds)}
        >
          <div className={classnames(styles.count, card.className)}>{card.value}</div>
          <div className={styles.title}>{card.title}</div>
        </button>
      ))}
    </div>
  );
};

export default HospitalCounters;
